module.exports = __webpack_public_path__ + "static/media/cabel.9512da12.jpg";